import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';

const QR_FOLDER = 'RestroAI/QR';

function dataUrlToBase64(dataUrl) {
    if (typeof dataUrl !== 'string') return '';
    const comma = dataUrl.indexOf(',');
    return comma >= 0 ? dataUrl.slice(comma + 1) : dataUrl;
}

function triggerBrowserDownload(dataUrl, filename) {
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

/**
 * Persists a data URL: on Capacitor Android/iOS writes under Documents/RestroAI/QR;
 * in the browser uses a download link (Chrome handles this; WebView often does not).
 */
export async function saveDataUrlAsFile(filename, dataUrl) {
    if (!dataUrl || typeof dataUrl !== 'string') {
        throw new Error('Invalid data URL');
    }

    if (Capacitor.isNativePlatform()) {
        const base64 = dataUrlToBase64(dataUrl);
        const path = `${QR_FOLDER}/${filename}`.replace(/\/+/g, '/');
        await Filesystem.writeFile({
            path,
            data: base64,
            directory: Directory.Documents,
            recursive: true,
        });
        return { native: true, path };
    }

    triggerBrowserDownload(dataUrl, filename);
    return { native: false };
}

export function savedFileHint(result) {
    if (!result?.native) return null;
    return `Saved to Documents/${result.path}`;
}
